import {Category} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/category.types';
import {useMergedPath} from '../../../shared-deprecated/useMergedPath';
import {useBrandShopPath} from '../utils/useBrandShopPath';

const EXCLUDE_PARAMS = new Set(['page']);
export const useBackPath = (parentCategory?: Category) => {
  const getMergedPath = useMergedPath();
  const brandShopPath = useBrandShopPath();

  if (!parentCategory) {
    return;
  }

  return getMergedPath({
    path: brandShopPath(parentCategory.id),
    config: {excludeUrlParams: EXCLUDE_PARAMS},
  });
};
